import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { navigateToCategory, rowItemCount } from "../../../../utils/utils";
import Translate from "../../../../Components/Multilanguage/Translate";
import { ReactComponent as GodtvTvIcon } from "../../../../assets/Icons/godtv-tv.svg";

const GaiaGenres = ({ data }) => {
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const isRTL = useSelector((state) => state?.rtl?.isRTL);
  const navigate = useNavigate();
  const [swiperKey, setSwiperKey] = useState(0);
  const template = projectInfo?.projectConfig?.config?.TEMPLATE;
  const kids = template === "TEMPLATE_12";
  const itemShape = data?.thumbnail_orientation || "ROUND";  
  const imageRequired = data?.image_required;

  const enableCustomRowCount = true;
  const visibleCount = (enableCustomRowCount && data?.visible_items_count) ? Math.ceil(Number(data.visible_items_count)) : 5;
  const count = data?.shows?.length || 0;
  const isShortList = count > 0 && count <= visibleCount;
  let displayedData = data?.shows;

  if(isRTL && count > visibleCount){
    displayedData = [...displayedData].reverse();
  }

  useEffect(() => {
    setSwiperKey((prevKey) => prevKey + 1);
  }, [isRTL]);
  
  return (
    <div className={`gaiaGenresContainer ${(projectInfo?.projectConfig?.pubid === 50167) ? "template-12" : (template === "TEMPLATE_9" || template === "TEMPLATE_12") ? "template-9" : ""} ${kids ? "kids" : ""} ${isRTL ? (count > visibleCount ? "ltr" : "rtl") : ""}`}
      role="region"
      aria-label="Genres Section"
>
      <div className="wrapper">
        <div className="header">
          <h1>
            {projectInfo?.projectConfig?.pubid=== 50146 ? null
              : (data?.category_name || <Translate textKey={'genres'} />)
            }</h1>
        </div>
        <Swiper
        key={swiperKey}
          modules={[Navigation]}
          // spaceBetween={10}
          slidesPerView={visibleCount}
          slidesPerGroup={visibleCount}
          navigation={true}
          watchSlidesProgress
          loop={false}
          initialSlide={(isRTL && count > visibleCount) ? count : 0}
          className={`${projectInfo?.projectConfig?.pubid === 50146 ? "newvibeitems" : "items"} ${isShortList ? "centered" : ""}`}
          breakpoints={{
            320: {
              slidesPerView: 1,
              slidesPerGroup: 1,
              // spaceBetween: 20,
            },
            481: {
              slidesPerView: 2,
              slidesPerGroup: 2,
              // spaceBetween: 20,
            },
            769: {
              slidesPerView: 3,
              slidesPerGroup: 3,
              // spaceBetween: 20,
            },
            981: {
              slidesPerGroup: 4,
              slidesPerView: 4,
              // spaceBetween: 20,
            },
            1201: {
              slidesPerGroup: enableCustomRowCount ? visibleCount : 5,
              slidesPerView: enableCustomRowCount ? visibleCount : 5,
              // spaceBetween: 20,
            },
          }}
          aria-label="Genres Carousel"
        >
          {displayedData?.map((item, index) => (
            <SwiperSlide key={index} className="category-slide" aria-label={`Genre Slide ${index + 1}`}> 
              <div
                className={`category-name ${itemShape}`}
                onClick={() => navigateToCategory(navigate, displayedData[index])}
                role="button"
                tabIndex={0}
                aria-label={`Go to category ${item?.category_name}`}
                onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') navigateToCategory(navigate, displayedData[index]); }}
              >
                {(imageRequired && item?.logo) ? (
                  <div className={`${itemShape}-container ${ projectInfo?.projectConfig?.pubid === 50146 ? "genre-container" : "" }`} >
                    <img 
                      src={item?.logo} 
                      onError={(e) => {
                        e.target.src = projectInfo?.projectConfig?.config?.PLACEHOLDER_IMAGE;
                      }}
                      alt={item?.category_name ? `${item.category_name} banner` : "Banner"}
                    />
                  </div>
                ) : (
                  <div className={`${itemShape}-container placeholder ${ projectInfo?.projectConfig?.pubid === 50146 ? "newvibeGenre" : "" }`} >
                    {!kids && (
                      <h1 className={projectInfo?.projectConfig?.pubid === 50146 ? "newvibeplaceholder-text" : "placeholder-text"}>
                        {item?.show_name ? item?.show_name : item?.category_name}
                      </h1>
                    )}
                  </div>
                )}
                {kids && itemShape === "ROUND" && (
                  <div className="kids-genre-icon-overlay">
                    <div className="kids-genre-icon-inner">
                      <GodtvTvIcon />
                      <span className="genre-name">{item?.show_name}</span>
                    </div>
                  </div>
                )}
                {/* <div 
                  className={`genre-name ${
                    template === "TEMPLATE_10" 
                      ? "gaia" 
                      : template === "TEMPLATE_9" 
                      ? "template_9" 
                      : ""
                  }`}
                >
                  {(imageRequired && item?.logo) &&
                    item?.category_name
                  }
                </div> */}
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default GaiaGenres;
